// src/layouts/MainLayout.jsx
import React, { useState } from 'react';
import { Layout, Dropdown, Menu, Badge, Avatar, message, Button } from 'antd';
import { 
  BellOutlined, 
  UserOutlined, 
  DownOutlined, 
  LogoutOutlined,
  SettingOutlined,
  DashboardOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined 
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const { Header, Content } = Layout;

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  
  // Récupérer les informations utilisateur
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    message.success('Déconnexion réussie !');
    navigate('/login');
  };

  // Menu pour le dropdown du profil
  const profileMenu = (
    <Menu className="min-w-[200px]">
      <Menu.Item key="user-info" disabled className="cursor-default opacity-100">
        <div className="py-1">
          <div className="font-semibold text-sm text-gray-800">
            {user.username || 'Utilisateur'}
          </div>
          <div className="text-xs text-gray-600 mt-0.5">
            {user.role === 'admin' ? 'Administrateur' : 'Utilisateur'}
          </div>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item 
        key="dashboard" 
        icon={<DashboardOutlined />}
        onClick={() => navigate('/dashboard')}
        className="hover:bg-gray-100"
      >
        Tableau de bord
      </Menu.Item>
      <Menu.Item 
        key="profile" 
        icon={<UserOutlined />}
        onClick={() => navigate('/profile')}
        className="hover:bg-gray-100"
      >
        Mon profil
      </Menu.Item>
      <Menu.Item 
        key="settings" 
        icon={<SettingOutlined />}
        onClick={() => navigate('/settings')}
        className="hover:bg-gray-100"
      >
        Paramètres
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item 
        key="logout" 
        icon={<LogoutOutlined />}
        onClick={handleLogout}
        className="text-red-500 hover:bg-red-50"
      >
        Déconnexion
      </Menu.Item>
    </Menu>
  );

  const notificationsMenu = (
    <Menu className="min-w-[300px]">
      <Menu.Item key="header" disabled className="font-semibold text-sm">
        Notifications
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="1" className="hover:bg-gray-100">
        <div>
          <div className="font-medium">Nouvelle commande reçue</div>
          <div className="text-xs text-gray-600">Il y a 2 heures</div>
        </div>
      </Menu.Item>
      <Menu.Item key="2" className="hover:bg-gray-100">
        <div>
          <div className="font-medium">Véhicule à entretenir</div>
          <div className="text-xs text-gray-600">Demain à 10:00</div>
        </div>
      </Menu.Item>
      <Menu.Item key="3" className="hover:bg-gray-100">
        <div>
          <div className="font-medium">Paiement en attente</div>
          <div className="text-xs text-gray-600">Depuis 3 jours</div>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="view-all" className="text-center hover:bg-gray-100">
        <Button type="link" size="small">Voir toutes les notifications</Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="min-h-screen bg-gray-50">
      <Header 
        className="bg-primary-500 px-6 flex items-center justify-between shadow-md sticky top-0 z-50 h-16 leading-[64px]"
      >
        <div className="flex items-center gap-4">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="text-white text-base w-12 h-12"
          />
          
          <img 
            src='/images/latyr.png' 
            alt="Logo Latyr" 
            className="h-10 w-10 rounded-full border-2 border-white/20 object-cover"
          />
          
          <div className="flex flex-col leading-tight">
            <h1 className="text-white m-0 text-lg font-semibold">
              LATYR GLOBAL BUSINESS
            </h1>
            <span className="text-white/80 text-xs font-normal">
              Gestion Transport et Logistique Simplifiée
            </span>
          </div>
        </div>
        
        <div className="flex items-center gap-4">
        
          {/* Profil utilisateur */}
          <Dropdown 
            overlay={profileMenu} 
            trigger={['click']} 
            placement="bottomRight"
            overlayClassName="mt-3"
          >
            <div className="cursor-pointer flex items-center px-3 py-1 rounded-lg bg-white/10 transition-all border border-white/20 hover:bg-white/20">
              <Avatar 
                className="bg-blue-500 mr-2 border-2 border-white"
                size="default"
                icon={<UserOutlined />}
              />
              <div className="flex flex-col mr-2">
                <span className="text-white text-sm font-medium leading-tight">
                  {user.username || 'Utilisateur'}
                </span>
                <span className="text-white/70 text-xs leading-tight">
                  {user.role === 'admin' ? 'Admin' : 'User'}
                </span>
              </div>
              <DownOutlined className="text-white/70 text-xs" />
            </div>
          </Dropdown>
        </div>
      </Header>
      
      <Layout>
        <Sidebar collapsed={collapsed} />
        <Layout 
          className={`transition-all bg-gray-50 min-h-[calc(100vh-64px)] ${
            collapsed ? 'ml-20' : 'ml-52'
          }`}
        >
          <Content className="p-6 m-0 min-h-[calc(100vh-64px)] overflow-initial">
            <div className="bg-white rounded-xl shadow-sm min-h-[calc(100vh-112px)] p-6">
              {children}
            </div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout;